/* global module, require */
import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

const title = "Mytender.io Task Pane Add-in";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
// Open wider than Word's default (about 270-330px) so the questions and chat
// have room. Once per opening: a width the user drags to is theirs. Hosts
// without TaskPaneApi 1.1 (iPad, older Word) keep their default.
const OPEN_WIDTH = 420;

Office.onReady(() => {
  try {
    if (Office.context.requirements.isSetSupported("TaskPaneApi", "1.1")) {
      (
        Office as unknown as { extensionLifeCycle?: { taskpane?: { setWidth: (w: number) => void } } }
      ).extensionLifeCycle?.taskpane?.setWidth(OPEN_WIDTH);
    }
  } catch {
    // Width is a nicety; the pane works at any width.
  }
  root?.render(
    <FluentProvider theme={webLightTheme}>
      <App title={title} />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
